import { render, staticRenderFns } from "./CreateBag.vue?vue&type=template&id=64354a16&scoped=true"
import script from "./CreateBag.vue?vue&type=script&lang=js"
export * from "./CreateBag.vue?vue&type=script&lang=js"
import style0 from "./CreateBag.vue?vue&type=style&index=0&id=64354a16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64354a16",
  null
  
)

export default component.exports